import React, { Component } from 'react';
import { HashRouter, Route } from 'react-router-dom';

import Home from './components/Home';
import Configurator from './components/Configurator';
import MyDocument from './components/MyDocument';

import './App.scss';

class App extends Component {
  constructor() {
    super();

    this.state = {
      width: 0
    };

    window.addEventListener("resize", this.update);
  }

  componentDidMount() {
    this.update();
  }

  update = () => {
    this.setState({
      width: window.innerWidth
    });
  };

  render() {
    return (
      <div className="App">
        <div className="aboveTablet">
          <HashRouter>
            <Route path="/" exact component={Home}/>
            <Route path="/configurator" exact component={Configurator}/>
            <Route path="/preview" exact component={MyDocument}/>

            <Route path="/en" exact component={Home}/>
            <Route path="/en/configurator" exact component={Configurator}/>
            <Route path="/en/preview" exact component={MyDocument}/>

            <Route path="/de" exact component={Home}/>
            <Route path="/de/configurator" exact component={Configurator}/>
            <Route path="/de/preview" exact component={MyDocument}/>
          </HashRouter>
        </div>
        <div className="underTablet">
          <div className="container container__home container__homeMain">
            <div className="container__info">
              <p className="p--xl color--blackSecond">Sorry!</p>
              <p className="p--xl color--blackSecond">The application is not available in this resolution.</p>
              <p className="color--grayFourth">
                The minimum width for this application is 1024 px. Your current screen width is: <span> {this.state.width} px </span>. Run the application on another device or enlarge the browser window.
              </p>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default App;
